import { useTranslation } from 'react-i18next';

import { Flex, Modal } from 'antd';

import useIsMobile from '@shared/hooks/useIsMobile';

import css from './RepeatDisclaimer.module.scss';

const RepeatDisclaimer = () => {
  const { t } = useTranslation('RepeatDisclaimer');
  const [modal, modalHolder] = Modal.useModal();
  const [isMobile] = useIsMobile(769);

  const Modals = async (from = 'all') => {
    const modalFooter = originNode => (
      <Flex justify='flex-end' className={css['RepeatDisclaimer-footer']} wrap gap={8} vertical={isMobile}>
        {originNode}
      </Flex>
    );

    switch (from) {
      case 'collectionMaterialId':
        return new Promise(resolve => {
          modal.confirm({
            title: t('title'),
            content: t('contents.collectionMaterialId'),
            icon: null,
            width: 800,
            okText: t('buttons.collectionMaterialId.ok'),
            cancelText: t('buttons.collectionMaterialId.cancel'),
            centered: true,
            footer: modalFooter,
            onOk: () => {
              resolve(true);
            },
            onCancel: () => {
              resolve(false);
            },
          });
        });

      default:
        return new Promise(resolve => {
          modal.confirm({
            title: t('title'),
            content: t('contents.all'),
            icon: null,
            width: 800,
            okText: t('buttons.all.ok'),
            cancelText: t('buttons.all.cancel'),
            centered: true,
            footer: modalFooter,
            onOk: () => {
              resolve(true);
            },
            onCancel: () => {
              resolve(false);
            },
          });
        });
    }
  };

  RepeatDisclaimer.Modal = Modals;

  return <>{modalHolder}</>;
};

export default RepeatDisclaimer;
